module.exports = __webpack_public_path__ + "img/logo.9b86f3f8.png";